<script setup>
import {InformationCircleIcon} from '@heroicons/vue/outline'
import {computed} from "vue";

const props = defineProps({
  type: String,
})

const styleClasses = computed(() => {
  switch(props.type){
    case 'warning':
      return 'bg-warning-100 text-warning-700'
    case 'danger':
      return 'bg-danger-100 text-danger-700'
    default:
      return 'bg-indigo-100 text-indigo-700'
  }
});

</script>

<template>
  <div class="shadow rounded-md p-4" :class="styleClasses">
    <div class="flex">
      <div class="flex-shrink-0">
        <InformationCircleIcon class="h-5 w-5" aria-hidden="true"/>
      </div>
      <div class="ml-3 flex-grow">
        <slot></slot>
      </div>
    </div>
  </div>
</template>